import {isRelativeUrl} from "./is-relative-url.ts";
import {parseUrl} from "./parse-url.ts";
import {toRelativeUrl} from "./to-relative-url.ts";

/**
 * Builds a URL as a string maintaining utm params for marketing purposes.
 *
 * Marketing often utilizes utm query params for tracking user journey info
 * when linking to KA.
 *
 * This function's purpose is to pull specific utm_* parameters out of a url
 * and build a url string with those params.
 *
 * @param url The URL to append the utm params onto
 * @param params The search params for the utm params
 */
export const preserveMarketingParams = (
    url: string,
    params: URLSearchParams,
): string => {
    const paramsToPreserve = new Set([
        "utm_id",
        "utm_source",
        "utm_campaign",
        "utm_medium",
        "isparent",
    ]);

    const parsedUrl = parseUrl(url);

    for (const [key, value] of params.entries()) {
        if (paramsToPreserve.has(key.toLowerCase())) {
            parsedUrl.searchParams.set(key.toLowerCase(), value);
        }
    }

    // Parsing the URL and then converting it to a string will add the domain
    // to the URL. If that url is then used in a redirect it forces a full page
    // reload. Therefore to prevent that we need to detect if the original URL
    // was relative, and if so, return a relative parsed URL.
    if (isRelativeUrl(url)) {
        return toRelativeUrl(parsedUrl.toString());
    }

    return parsedUrl.toString();
};
